import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { delay, tap } from 'rxjs/operators';
import { IDeveloper } from './../../../../src/app/shared/models/models';
import { environment } from './../../../../src/environments/environment';

@Injectable()
export class OrganizationService {

  apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  getCompanyFromKompra(bin: string): Observable<IKompraCompany> {
    let url = this.apiUrl + `Organizations/GetOrganizationByKompra?Identifier=${bin}`;
    return this.http.get<IKompraCompany>(url, { }).pipe(
      delay(100)
    );
  }

  getOrganizations(typeId: number | any): Observable<Array<IOrganizationInfoSearch>> {
    let url = this.apiUrl + `Organizations/GetOrganizations?TypeID=${typeId}`;
    return this.http.get<Array<IOrganizationInfoSearch>>(url, { });
  }


  // 2. Organizations/InfoSearch?Query= SearchFlag= TypeID= - Поиск организаций где
  // Query - строка для поиска,
  // SearchFlag - 0,NULL - искать по БИНу, 1 - искать по наименованию,
  // TypeID - ID типа, NULL - искать по всем типам
  infoSearch(query: string, searchFlag: boolean, typeId: number): Observable<Array<IOrganizationInfoSearch>> {
    let url = this.apiUrl + `Organizations/InfoSearch?Query=${query}&SearchFlag=${searchFlag}&TypeID=${typeId}`;
    return this.http.get<Array<IOrganizationInfoSearch>>(url, { });
  }

  getOrganizationByBin(bin: string): Observable<IOrganizationInfo> {
    let url = this.apiUrl + `Organizations/GetByBin?Bin=${bin}`;
    return this.http.get<IOrganizationInfo>(url, { });
  }

  getOrganizationTypes(): Observable<Array<IOrganizationType>> {
    let url = this.apiUrl + `Organizations/GetTypes`;
    return this.http.get<Array<IOrganizationType>>(url, { });
  }

  createOrganization(organization: IOrganizationInfo) {
    let url = this.apiUrl + `Organizations/Add`;
    return this.http.post(url, organization);
  }

  updateOrganization(organization: IOrganizationInfo) {
    let url = this.apiUrl + `Organizations/Update`;
    return this.http.put(url, organization);
  }


}

export enum TypeIds {
  'general_contractor' = 1,
  'author_supervision' = 2,
  'technical_supervision' = 3,
  'private_partner' = 4,
  'authorized_organization' = 5,
  'customer' = 6,
}

export enum TypeIdsTitle {
  'general_contractor' = 'Контактная информация согласно заключенному договору о государственных закупках в сфере строительства с генеральным подрядчиком',
  'author_supervision' = 'Контактная информация согласно заключенному договору о государственных закупках услуг с авторским надзором',
  'technical_supervision' = 'Контактная информация согласно заключенному договору о государственных закупках услуг с техническим надзором',

  'private_partner' = 'Контактная информация согласно заключенному договору о государственных закупках услуг с частным партнером',
  'authorized_organization' = 'Контактная информация согласно заключенному договору о государственных закупках услуг с уполномоченной компанией',
}


export type IOrganizationTypeShortName = 'responsible' | 'general_contractor' | 'author_supervision' | 'technical_supervision' | 'supervisor' | 'private_partner' | 'authorized_organization' | 'curators'; // для портала БД и ФГЖС

export interface IOrganizationType {
  id: number;
  title: string;
  active?: boolean;
  disabled?: boolean;
}
export interface IOrganizationInfoSearch {
  bin: string;
  title: string;
  types: Array<number>;
  active?: boolean;
}

export interface IOrganizationInfoBase {
  bin: string;
  title: string;
  director: string;
  physicalAddress: string;
  registerAddress: string;
  contactPerson: string;
}

export interface IOrganizationInfo extends IOrganizationInfoBase {
  bin: string;
  oldBin?: string;
  title: string;
  director: string;
  physicalAddress: string;
  registerAddress: string;
  contactPerson: string;
  typeList: Array<number>;
  details: Array<ICompanyDetails>;
  isValidBIN?: boolean;
}

export interface IKompraCompany {
  name: string;
  fullName: string;
  bin: string;
  rnn: string;
  iin: string;
  field: Array<string>;
  factAddress: string;
  region: string;
  lawAddress: string;
  okpo: string;
  oked: string;
  owner: string;
  registerDate: number;
  workers: string;
  size: string;
  ownership: string;
  kato: string;
  city: string;
  street: string;
  secondaryOked: string;
  kbe: string;
  phone: string;
  email: string;
  website: string;
}



export interface ICompanyDetails {
  /** false - основной, true - дополнительный */
  extra?: boolean;

  /** один из 3 тип элемента: 'phone','web','email' */
  kind?: 'phone' | 'web' | 'email';

  /** номер по-порядку в пределах каждого типа для каждого вида (основной или дополнительный) */
  order?: number;

  /** Значение поля */
  value?: string;

  /** Источник получения информации */
  source?: 'kompra.kz' | 'user',

  errorEmail?: boolean;
}


export interface ISelectItemEvent {
  key: string;
  value: IDeveloper;
}
